define([
	"jquery",
	"underscore",
	"marionette",
	"behaviors/form_errors_behavior",
	"templates/payout/internal_transfer_item.html",
    "forms/payout/internal_transfer_form",
	"behaviors/datatables_behavior",
	"backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior, InternalTransferTemplate, InternalTransferForm, DatatablesBehavior) {

	return Marionette.View.extend({
		el: '#content_layout',

		behaviors: {
			formErrors: {
				behaviorClass: FormErrorsBehavior
			},
			datatables: {
				behaviorClass: DatatablesBehavior
			}
		},

		ui: {
			'transferRowList': '#additional_transfer_row_list',
			'fromMt40': '#from_mt4_0',
			'toMt40': '#to_mt4_0',
			'amount0': '#amount_0',
			'addTransferButton': '#add_transfer',
			'fromMt4Dropdown': '#from_mt4',
			'toMt4Dropdown': '#to_mt4',
			'removeTransferButton': '.minus_sign',

			// submit for button
			'submitFormButton': '#submit_btn',

			// the form
			'internalTransferForm': '#internal_transfer_form',
		},

		events: {
			'change @ui.accountDropdown' : 'changeAccountInput',
			'click @ui.addTransferButton' : 'addTransferRow',
			'click @ui.removeTransferButton': 'removeTransferRow',

			'click @ui.submitFormButton': 'submitForm',
		},

		initialize: function() {
			this.bindUIElements();
			this.initDatatable();
		},

		initDatatable: function() {
			this.triggerMethod('init:table', {
				url: '/rest_payout/internal_transfer_history',
				order: [[ 0, "desc" ]],
				columns: [
					{
						'name':'reg_datetime',
						'data':'reg_datetime',
						'type': 'date'
					},
					{
						'name':'amount',
						'data':'amount'
					},
					{
						'name':'type',
						'data':'type_trans'

					},
					{
						'name':'mt4',
						'data':'target_mt4'
					},
					{
						'name':'status',
						'data':'status_trans'
					}
				]
			});
		},

		changeAccountInput: function() {
			const accountNo = this.ui.accountDropdown.val();
			this.ui.accountInput.val(accountNo);
		},

		addTransferRow: function(e) {
			e.preventDefault();
			// const fromMt40 = this.ui.fromMt40.val();
			// const toMt40 = this.ui.toMt40.val();
			// const amount0 = this.ui.amount0.val();
			this.renderFormRow() // fromMt40, toMt40, amount0);
		},

		removeTransferRow: function(e) {
			e.preventDefault();

            const that = this;
			const targetElementId = '#transfer_row_' + e.target.dataset.idx;
			$(targetElementId).remove();

			// reset the index to display validation message in the proper index position
			_.forEach(that.ui.transferRowList.children(), function(child, index, array){
				const elemId = child.id;
				$(`#${elemId} > div > div > label`).attr('for', `from_mt4_${index}`);
				$(`#${elemId} > div > div > input`).attr('id', `from_mt4_${index}`);
				$(`#${elemId} > div > div > input`).attr('data-idx', `${index}`);
				$(`#${elemId} > div > div > span`).attr('for', `from_mt4_${index}`);

				$(`#${elemId} > div:nth-child(2) > div > label`).attr('for', `to_mt4_${index}`);
				$(`#${elemId} > div:nth-child(2) > div > input`).attr('id', `to_mt4_${index}`);
				$(`#${elemId} > div:nth-child(2) > div > input`).attr('data-idx', `${index}`);
				$(`#${elemId} > div:nth-child(2) > div > span`).attr('for', `to_mt4_${index}`);

				$(`#${elemId} > div:nth-child(3) > div > label`).attr('for', `amount_${index}`);
				$(`#${elemId} > div:nth-child(3) > div > input`).attr('id', `amount_${index}`);
				$(`#${elemId} > div:nth-child(3) > div > input`).attr('data-idx', `${index}`);
				$(`#${elemId} > div:nth-child(3) > div > span`).attr('for', `amount_${index}`);

				$(`#${elemId} > div:nth-child(4) > button`).attr('id', `minus_button_${index}`);
				$(`#${elemId} > div:nth-child(4) > button > i`).attr('data-idx', `${index}`);

				$(`#${elemId}`).attr('id', `transfer_row_${index}`);
			});
		},

		renderFormRow: function() {
			const that = this;
			const translationFrom = window.translation_from_mt4;
			const translationTo = window.translation_to_mt4
			const translationAmount = window.translation_amount;

			that.ui.transferRowList.append(InternalTransferTemplate({
				idx: that.ui.transferRowList.children().length,
				translation_from: translationFrom,
				translation_to: translationTo,
				translation_amount: translationAmount,
				mode: window.mode,
				transferable_clients: window.transferable_clients,
				trade_account_no: window.trade_account_no,
			}));
		},

		submitForm: function(e) {
			if (e) e.preventDefault();
			const that = this;

			that.triggerMethod('hide:errors');

			// Since we want to validate each row, we'll have to loop on all of them and build the errors array
			const errors = {};
			const form = new InternalTransferForm();
			const formData = Backbone.Syphon.serialize(that.ui.internalTransferForm);

			// For each "from_mt4"
			_.each(formData.from_mt4, function(value, index, array) {
				form.set({
					from_mt4: value,
					to_mt4: formData.to_mt4[index],
					amount: formData.amount[index]
				});

				const rowErrors = form.validate();

				// Errors!
				if (_.size(rowErrors) > 0) {
					// Loop on them and add them to the errors array with the correct index
					_.each(rowErrors, function (v, i, a) {
						errors[i + "_" + index] = v;
					});
				}
			});

			if (_.size(errors) < 1) {
				that.ui.internalTransferForm.submit();
			} else {
				this.triggerMethod('show:errors', errors);
			}
		}
	});
});
